// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nul li[data-v-45cf773e] {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.6;\n}\nul li b[data-v-45cf773e] {\n  font-weight: 600;\n}\n.icon-holder[data-v-45cf773e] {\n  margin: 0.5rem 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
